'use es6';

import apiClient from 'hub-http/clients/apiClient';
import Immutable from 'immutable';
const API_PATH = '/cosindex/api/v1/connections';
export function fetchParents(id) {
  return apiClient.get(`${API_PATH}/${id}/parents`, {
    query: {
      levels: 0,
      fields: 'BASIC'
    }
  }).then(Immutable.fromJS);
}